import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
// import '../../../styles/components/_appNavBar.scss';
import 'src/styles/components/_subNavBar.scss';
import { Navbar, NavbarGroup } from '@blueprintjs/core';
import UserDetails from 'src/models/UserDetails';
import Permissions from 'src/models/Permissions';
import selectors from 'src/selectors';
import Authorization from 'src/util/Authorization';

const PersonnelNavBar: React.FC = () => {
    type page = 
        'personnel' | 
        'paperwork' | 
        'scorecard' | 
        'contract-pay' | 
        'billing' | 
        'employee-pay' | 
        'employee-benefits' | 
        'insurance-history' | 
        'benefits-history' | 
        'rates' |
        'overview' |
        'check-register' |
        'employee-payroll' |
        'commission' |
        'director-commission';

    const dispatch = useDispatch();
    const currentUser = useSelector(selectors.auth.user) as UserDetails;
    // The four payroll screens sit behind back_office.payroll on the server. Hiding them here is
    // purely so a user without it never sees a tab that would bounce them to the 403 page - the
    // real gate is PayrollController/CommissionController, and deep-linking still hits it.
    const hasPayrollAccess = Authorization.HasPermission(Permissions.BackOfficePayroll, currentUser);
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/paperwork') >= 0) {
            setCurrentSection('paperwork');
        } else if (window.location.pathname.indexOf('/scorecard') >= 0) {
            setCurrentSection('scorecard');
        } else if (window.location.pathname.indexOf('/contract-pay') >= 0) {
            setCurrentSection('contract-pay');
        } else if (window.location.pathname.indexOf('/billing') >= 0) {
            setCurrentSection('billing');
        } else if (window.location.pathname.indexOf('/employee-payroll') >= 0) {
            setCurrentSection('employee-payroll');
        } else if (window.location.pathname.indexOf('/employee-pay') >= 0) {
            setCurrentSection('employee-pay');
        } else if (window.location.pathname.indexOf('/employee-benefits') >= 0) {
            setCurrentSection('employee-benefits');
        } else if (window.location.pathname.indexOf('/insurance-history') >= 0) {
            setCurrentSection('insurance-history');
        } else if (window.location.pathname.indexOf('/benefits-history') >= 0) {
            setCurrentSection('benefits-history');
        } else if (window.location.pathname.indexOf('/rates') >= 0) {
            setCurrentSection('rates');
        } else if (window.location.pathname.indexOf('/overview') >= 0) {
            setCurrentSection('overview');
        } else if (window.location.pathname.indexOf('/check-register') >= 0) {
            setCurrentSection('check-register');
        } else if (window.location.pathname.indexOf('/director-commission') >= 0) {
            setCurrentSection('director-commission');
        } else if (window.location.pathname.indexOf('/commission') >= 0) {
            setCurrentSection('commission');
        } else {
            setCurrentSection('personnel');
        }
    });

    const navigate = (path: string) => {
        if (window.location.pathname.includes('personnel/') && currentSection) {
            let newPath = path.replace('personnel/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="nav-bar" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }} >
            <NavbarGroup style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto', flexWrap: 'wrap', gap: '8px' }}>
                <div className={'sub-nav-menu-item ' + isActive('personnel')} onClick={() => navigate('personnel/home')}>
                    Personnel Info
                </div>
                <div className={'sub-nav-menu-item ' + isActive('paperwork')} onClick={() => navigate('personnel/paperwork')}>
                    Paperwork & Access
                </div>
                <div className={'sub-nav-menu-item ' + isActive('scorecard')} onClick={() => navigate('personnel/scorecard')}>
                    Scorecard
                </div>
                <div className={'sub-nav-menu-item ' + isActive('contract-pay')} onClick={() => navigate('personnel/contract-pay')}>
                    Contract Pay
                </div>
                <div className={'sub-nav-menu-item ' + isActive('billing')} onClick={() => navigate('personnel/billing')}>
                    Billing
                </div>
                <div className={'sub-nav-menu-item ' + isActive('employee-pay')} onClick={() => navigate('personnel/employee-pay')}>
                    Employee Pay
                </div>
                <div className={'sub-nav-menu-item ' + isActive('overview')} onClick={() => navigate('personnel/overview')}>
                    Personnel Overview
                </div>
                <div className={'sub-nav-menu-item ' + isActive('employee-benefits')} onClick={() => navigate('personnel/employee-benefits')}>
                    Employee Benefits
                </div>
                <div className={'sub-nav-menu-item ' + isActive('insurance-history')} onClick={() => navigate('personnel/insurance-history')}>
                    Insurance History
                </div>
                <div className={'sub-nav-menu-item ' + isActive('benefits-history')} onClick={() => navigate('personnel/benefits-history')}>
                    Benefits History
                </div>
                <div className={'sub-nav-menu-item ' + isActive('rates')} onClick={() => navigate('personnel/rates')}>
                    Rate Table
                </div>
                {hasPayrollAccess && (
                    <>
                        <div className={'sub-nav-menu-item ' + isActive('check-register')} onClick={() => navigate('personnel/check-register')}>
                            Check Register
                        </div>
                        <div className={'sub-nav-menu-item ' + isActive('employee-payroll')} onClick={() => navigate('personnel/employee-payroll')}>
                            Employee Payroll
                        </div>
                        <div className={'sub-nav-menu-item ' + isActive('commission')} onClick={() => navigate('personnel/commission')}>
                            Commission
                        </div>
                        <div className={'sub-nav-menu-item ' + isActive('director-commission')} onClick={() => navigate('personnel/director-commission')}>
                            Director Commission
                        </div>
                    </>
                )}
            </NavbarGroup>
        </Navbar>
    );
};

export default PersonnelNavBar;



// WEBPACK FOOTER //
// ./src/components/personnel/components/PersonnelNavBar.tsx